import { Box, Grid } from "@mui/material";
import { useTranslate } from "src/locales";
import ByzTitleBox from "./title-box";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";

function RequestInformation() {
  const { t } = useTranslate();

  interface DataRequest {
    id: string;
    requestdate: string;
    serialno: string;
    unitnumber: string;
    desiredcomponent: string;
    componentno: string;
    componentquantity: string;
    bloodcollectiondate: string;
    skt: string;
    supplier: string;
    select: string;
  }

  const requestInfo: DataRequest[] = [
    {
      id: "1",
      requestdate: "Örnek Data",
      serialno: "Örnek Data",
      unitnumber: "Örnek Data",
      desiredcomponent: "Örnek Data",
      componentno: "Örnek Data",
      componentquantity: "Örnek Data",
      bloodcollectiondate: "Örnek Data",
      skt: "Örnek Data",
      supplier: "Örnek Data",
      select: "",
    },
  ];

  const columns = [
    {
      field: "select",
      headerName: t("catheter-material-tracking.select"),
      width: 80,
      renderCell: () => <ByzMuiCheckBox />,
    },
    {
      field: "requestdate",
      headerName: t("blood-transfusion.columns.request-date"),
      flex: 1,
    },
    {
      field: "serialno",
      headerName: t("blood-transfusion.columns.serial-no"),
      flex: 1,
    },
    {
      field: "unitnumber",
      headerName: t("blood-transfusion.columns.unit-number"),
      flex: 1,
    },
    {
      field: "desiredcomponent",
      headerName: t("blood-transfusion.columns.desired-component"),
      flex: 1,
    },
    {
      field: "componentno",
      headerName: t("blood-transfusion.columns.component-no"),
      flex: 1,
    },
    {
      field: "componentquantity",
      headerName: t("blood-transfusion.columns.component-quantity"),
      flex: 1,
    },
    {
      field: "bloodcollectiondate",
      headerName: t("blood-transfusion.columns.blood-collection-date"),
      flex: 1,
    },
    {
      field: "skt",
      headerName: t("blood-transfusion.columns.skt"),
      flex: 1,
    },
    {
      field: "supplier",
      headerName: t("blood-transfusion.columns.supplier"),
      flex: 1,
    },
  ];

  return (
    <Box>
      <ByzTitleBox title={t("blood-transfusion.request-Information")} />

      <Grid
        item
        xs={12}
        container
        sx={{ display: "flex", flexWrap: "wrap", ml: "8px", mr: "8px" }}
      >
        <Box sx={{ width: "98%" }}>
          <ByzMuiDataGrid
            columns={columns}
            disableProcessMenu={true}
            pageSize={10}
            rows={requestInfo}
          />
        </Box>
      </Grid>
    </Box>
  );
}

export default RequestInformation;
